import { render, staticRenderFns } from "./MoveToFolderModal.vue?vue&type=template&id=00e36f78&"
import script from "./MoveToFolderModal.vue?vue&type=script&lang=js&"
export * from "./MoveToFolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports